import { Button, DialogActions, DialogContent, Stack } from "@mui/material";
import { Field } from "formik";
import { TextField } from "formik-mui";
import PopupState, { bindPopover, bindTrigger } from "material-ui-popup-state";
import { useId } from "react";
import { useTranslation } from "react-i18next";
import CloseButton from "../../components/CloseButton";
import Dialog from "../../components/dialog";
import { useCapitalize } from "../../i18n";

export default function SettingsButton() {
  const { t } = useTranslation("welcome");
  const capitalize = useCapitalize();

  return (
    <PopupState variant="popover" popupId={useId()}>
      {(popupState) => (
        <>
          <Button
            variant="text"
            size="small"
            color="inherit"
            sx={{ textTransform: "initial" }}
            {...bindTrigger(popupState)}
          >
            {capitalize(t("settings:label"))}
          </Button>
          <SettingsDialog {...bindPopover(popupState)} />
        </>
      )}
    </PopupState>
  );
}

function SettingsDialog({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) {
  const { t } = useTranslation("welcome");
  const capitalize = useCapitalize();

  return (
    <Dialog
      title={capitalize(t("settings:label"))}
      open={open}
      onClose={onClose}
    >
      <DialogContent>
        <Stack spacing={2} sx={{ pt: 1 }}>
          <Field
            component={TextField}
            name="serverUrl"
            label={capitalize(t("settings.serverUrl.label"))}
            helperText={capitalize(t("settings.serverUrl.info"))}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <CloseButton onClick={onClose} />
      </DialogActions>
    </Dialog>
  );
}
